import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { OnBoardingSchool } from '../../components/helps/OnBoardingSchool'



export default function Dashboard() {
    const { t } = useTranslation()

    return (
        <Container className='cuerpo'>
            <Card className='mb-5 sombra'>
                <Card.Body className='px-5 py-5'>
                    <Row>
                        <Col>
                            <h1>{t('dashboard.school.welcome')}</h1>
                            <p>{t('dashboard.school.subwelcome')}</p>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col className='onboarding'>
                            <h3 className='mb-4'>{t('dashboard.onboardingSchool.titleProcess')}</h3>
                            <div className='mt-2 mb-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.paragraph1')}}></div>
                            <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingSchool.paragraph2')}}></div>
                            <OnBoardingSchool/>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Container>
    )
}